<template>
  <div id="adminCrmRoles">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ registries }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ roles }}</router-link>
      </li>
    </ol>
<div class="container-fluid card-title-admin"> 
      <h1>{{ roles }}</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane active" id="tabTable" role="tabpanel">
            <div class="row align-btns">
              <div class="col-lg-12">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onNewRoles"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
                <button
                  id="btnSave"
                  type="button"
                  class="btn btn-success"
                  @click="confirmSaveNewRole"
                  :disabled="disableButton"
                >
                  <i class="fa fa-floppy-o"></i>
                  <span>{{ save }}</span>
                </button>
              </div>
            </div>      
            <div class="row">
              <div class="col-sm-12">
                <bootstrapTable
                  :configurations="TableRolesConfiguration"
                  :datas="tableData"
                  id="tableRoles"
                  :onCheck="onTableCheckRole"
                  :onCheckAll="onTableCheckRole"
                  :onUncheck="onTableCheckRole"
                  :onUncheckAll="onTableCheckRole"
                  ref="tableRoles"
                  :results="tableResult"
                ></bootstrapTable>
              </div>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabDetail" role="tabpanel">
            <div class="card-body" style="padding: 0px;">
              <div class="row">
                <div class="col-12">
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <button
                        id="tabAdminRolesGeneralButton"
                        class="nav-link active"
                        type="button"
                        data-toggle="tab"
                        href="#tabAdminRolesGeneral"
                        role="tab"
                        aria-controls="tabAdminRolesGeneral"
                        v-on:click="onTabAdminRolesGeneral"  
                      >
                        <span>Generale</span>
                      </button>
                    </li>
                 <!-----   <li class="nav-item">
                      <button
                        id="tabAdminRolesMenuButton"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabAdminRolesMenu"
                        role="tab"
                        aria-controls="tabAdminRolesMenu"  
                        v-on:click="onTabMenu"          
                      >
                        <span>Menù abilitati</span>
                      </button>
                    </li>---->
                  </ul>
                
                  <div class="tab-content">
                    <div class="tab-pane active" id="tabAdminRolesGeneral" role="tabpanel" style="box-shadow: none;padding: 28px;">
                      <div class="row">
                       <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                        <pageDetail
                          functions="adminCrmRoles"
                          :configurations="DetailRolesConfiguration"
                          :jsonValue="detailData"
                        ></pageDetail>
                      </div>
                      <div class="row">
                        <div class="col-12 text-right">
                          <button
                            type="button"
                            class="btn btn-danger"
                            data-dismiss="modal"
                            @click="confirmCancelNewRole"
                          >	<i class="fa fa-times"></i>&nbsp; {{ cancel }}</button>
                          <button
                            type="button"
                            class="btn btn-success"
                            @click="confirmSaveNewRole"
                          ><i class="fa fa-floppy-o"></i>&nbsp;{{ save }}</button>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="tabAdminRolesMenu" role="tabpanel">
                      <div class="row">
                        <div class="col-sm-5">
                          <bootstrapTable
                            addInput="false"
                            :configurations="tableMenuDisabledConfiguration"
                            :datas="tableMenuDisabledData"
                            id="MenuDisabled"
                            :onCheck="onTableMenuDisabledCheck"
                            :onCheckAll="onTableMenuDisabledCheck"
                            :onUncheck="onTableMenuDisabledCheck"
                            :onUncheckAll="onTableMenuDisabledCheck"
                            ref="tableMenuDisabled"
                            :results="tableRoleResult"
                          ></bootstrapTable> 
                    
                        </div>
                        <div class="col-sm-2 vertical-center">
                          <div class="container-fluid">
                     
                            <div class="row">
                              <button
                                type="button"
                                class="btn btn-block btn-primary"
                                @click="addMenu"
                                :disabled="disableAddMenuButton"
                              >
                                <i class="fa fa-arrow-right"></i>
                                <span>Aggiungi</span>
                              </button>
                            </div>


                            <div class="row">&nbsp;</div>
                                   <div class="row">
                              <button
                                type="button"
                                class="btn btn-block btn-primary"
                                @click="removeMenu"
                                :disabled="disableRemoveMenuButton"
                              >
                                <i class="fa fa-arrow-left"></i>
                                <span>Rimuovi</span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-5">
                            <bootstrapTable
                            addInput="false"
                            :configurations="tableMenuEnabledConfiguration"
                            :datas="tableMenuEnabledData"
                            id="MenuEnabled"
                            :onCheck="onTableMenuEnabledCheck"
                            :onCheckAll="onTableMenuEnabledCheck"
                            :onUncheck="onTableMenuEnabledCheck"
                            :onUncheckAll="onTableMenuEnabledCheck"
                            ref="tableMenuEnabled"
                          ></bootstrapTable>                
                        </div>
                      </div>
                      
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";

export default {
  name: "adminCrmRoles",
  components: {
    BootstrapTable,
    PageDetail
  },
  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      registries: dictionaryHelpers.getDictionary("registries"),
      roles: dictionaryHelpers.getDictionary("Roles"),
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      disableAddMenuButton: true,
      disableRemoveMenuButton: true,
      DetailRolesConfiguration: [],
      DetailMenuConfiguration: [],
      tableMenuDisabledConfiguration: [],
      tableMenuDisabledData: [],
      tableMenuEnabledConfiguration: [],
      tableMenuEnabledData: [],
      detailData: {},
      disableButton: true,
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      newTitleRoles: dictionaryHelpers.getDictionary("newTitleRoles"),
      openDetail: dictionaryHelpers.getDictionary("OpenDetail"),
      save: dictionaryHelpers.getDictionary("Save"),
      TableRolesConfiguration: [],
      tableRoleResult: [],
      tableData: [],
      tableResult: [],
      titleDetail: null,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname,
      rowIdSelected: 0,
      rowsSelected: 0
    };
  },
  created() {
    var adminCrmRoles = this;

    spinnerHelpers.show();
    adminConfigurationServices.getFunctionality(function(result) {
      if (functionHelpers.isValued(result) && functionHelpers.isValued(result.data)) {
        adminCrmRoles.TableRolesConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
        adminCrmRoles.DetailRolesConfiguration = result.data.tabsConfigurations[0].pageConfigurations;        
       // adminCrmRoles.tableMenuEnabledConfiguration = result.data.tablesConfigurations[1].tablesConfigurations;
      //  adminCrmRoles.tableMenuDisabledConfiguration = result.data.tablesConfigurations[2].tablesConfigurations;
      }

      adminCrmRoles.loadTable();
    });
  },
  methods: {
    onTabAdminRolesGeneral(){
      $('#tabAdminRolesMenu').removeClass("active");
      $('#tabAdminRolesGeneral').addClass("active");
    },
    onTabAdminRolesMenu(){
      $('#tabAdminRolesGeneral').removeClass("active");
      $('#tabAdminRolesMenu').addClass("active");
    },  
    loadTable() {
      var adminCrmRoles = this;

      rolesServices.getAllWithoutAdmin(function(result) {
        adminCrmRoles.tableData = result.data;
        spinnerHelpers.hide();
      });
    },

    RolesFormatter(value, row, index, field) {
      var adminCrmRoles = this;
      var html =
        '<div class="container-fluid nopadding" style="width:80px;"><div class="row">';
      html +=
        '<div class="col-1"><button class="btn btn-success" onclick="adminCrmRoles.__vue__.executeOpenDetail(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button></div>';

      if (functionHelpers.isValued(this.tableResult)) {
        $.each(this.tableResult, function(i, result) {
          if (result.id == row.id) {
            if (result.success) {
              html +=
                '<div class="col-1"><i class="fa fa-check text-success" title="';
              if (functionHelpers.isValued(result.message)) {
                html += result.message;
              } else {
                html += adminCrmRoles.updateCompleted;
              }
              html += '" /></div>';
            } else {
              html +=
                '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                result.message +
                '" /></div>';
            }
            return;
          }
        });
      }
      html += "</div></div>";
      return html;
    },

    executeOpenDetail(id) {
      spinnerHelpers.show();
      var adminCrmRoles = this;
      this.rowIdSelected = id;
      this.titleDetail = this.Role;

      $.each(this.tableData, function(i, row) {
        if (adminCrmRoles.rowIdSelected == row.id) {
          adminCrmRoles.detailData = row;
        }
      });

      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      $('#tabAdminRolesMenu').removeClass("active");
      $('#tabAdminRolesGeneral').addClass("active");

      spinnerHelpers.hide();
    },

    onNewRoles() {
      spinnerHelpers.show();
      this.detailData = {};
      adminCrmRoles.rowIdSelected = 0;
      this.titleDetail = this.newRole;
      this.rowIdSelected = 0;
      $("#tabTable").removeClass("active");
      $('#tabAdminRolesMenu').removeClass("active");
      $('#tabAdminRolesGeneral').addClass("active");
      $("#tabDetail").addClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveRole() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveRole();
      }
    },

    executeSaveRole() {
      spinnerHelpers.show();
      var adminCrmRoles = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableRole.getRowSelected(), function(i, row) {
        var rowToSave = row;
        rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
        adminCrmRoles.rowsSelected = adminCrmRoles.rowsSelected + 1;

        rolesServices.update(
          rowToSave,
          function() {
            adminCrmRoles.checkAllIsSaved();
            adminCrmRoles.tableResult.push({
              id: rowToSave.id,
              success: true
            });
            notificationHelpers.success(adminCrmRoles.updateCompleted);
          },
          function(response) {
            adminCrmRoles.checkAllIsSaved();
            adminCrmRoles.tableResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    confirmDeleteRole() {
      if (confirm(this.confirmDelete)) {
        this.executeDeleteRole();
      }
    },
    executeDeleteRole() {
      spinnerHelpers.show();
      var adminCrmRoles = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableRole.getRowSelected(), function(i, row) {
        adminCrmRoles.rowsSelected = adminCrmRoles.rowsSelected + 1;

        rolesServices.del(
          row.id,
          function() {
            adminCrmRoles.checkAllIsSaved();
            notificationHelpers.success(adminCrmRoles.deleteCompleted);
          },
          function(response) {
            adminCrmRoles.checkAllIsSaved();
            adminCrmRoles.tableResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    onTableCheckRole() {
      var countRowSelected = this.$refs.tableRole.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },

    confirmCancelNewRole() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmCancel"))) {
        this.executeCancelRole();
      }
    },

    executeCancelRole() {
      spinnerHelpers.show();
      this.detailTemplateEditorData = {};
      $("#tabTable").addClass("active");
      $("#tabAdminRolesGeneral").removeClass("active");
      $("#tabAdminRolesMenu").removeClass("active");
      $("#tabDetail").removeClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveNewRole() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveNewRole();
      }
    },

    executeSaveNewRole() {
      spinnerHelpers.show();
      var adminCrmRoles = this;
      this.detailData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (!functionHelpers.isValued(this.detailData.company)) {
        this.detailData.company = false;
      }

      if (!functionHelpers.isValued(this.detailData.sendNewsletter)) {
        this.detailData.sendNewsletter = false;
      }

      if (!functionHelpers.isValued(this.detailData.errorNewsletter)) {
        this.detailData.errorNewsletter = false;
      }

      if (
        functionHelpers.isValued(this.rowIdSelected) &&
        this.rowIdSelected > 0
      ) {
        this.detailData.id = this.rowIdSelected;

        rolesServices.update(this.detailData, function(result) {
          adminCrmRoles.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmRoles.updateCompleted
          });
          notificationHelpers.success(adminCrmRoles.updateCompleted);
          adminCrmRoles.loadTable();
          $("#tabTable").addClass("active");
          $("#tabAdminRolesGeneral").removeClass("active");
          $("#tabAdminRolesMenu").removeClass("active");
          $("#tabDetail").removeClass("active");
        });
      } else {
        rolesServices.insert(this.detailData, function(result) {
          adminCrmRoles.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmRoles.insertCompleted
          });
          notificationHelpers.success(adminCrmRoles.insertCompleted);
          adminCrmRoles.loadTable();
          $("#tabTable").addClass("active");
          $("#tabAdminRolesGeneral").removeClass("active");
          $("#tabAdminRolesMenu").removeClass("active");
          $("#tabDetail").removeClass("active");
        });
      }
    },

    checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.disableButton = true;
        this.loadTable();
      }
    },


    /***   MEnu   ***/

    onTabMenu() {

      $('#tabAdminRolesGeneral').removeClass("active");
      $('#tabAdminRolesMenu').addClass("active");

      var adminSettingRole = this;
      
      spinnerHelpers.show();

      menuAdminCustomServices.getByRole(this.detailData.id, function(result) {
        adminSettingRole.tableMenuEnabledData = result.data.included;
        adminSettingRole.tableMenuDisabledData = result.data.excluded;
        spinnerHelpers.hide();
      });
      
      this.disableAddMenuButton = true;
      this.disableRemoveMenuButton = true;
    },
    onTableMenuDisabledCheck() {
      if (this.$refs.tableMenuDisabled.countRowSelected() == 0) {
        this.disableAddMenuButton = true;
      } else {
        this.disableAddMenuButton = false;
      }
    },
    onTableMenuEnabledCheck() {
      if (this.$refs.tableMenuEnabled.countRowSelected() == 0) {
        this.disableRemoveMenuButton = true;
      } else {
        this.disableRemoveMenuButton = false;
      }
    },
    addMenu() {
      var adminSettingUser = this;
      this.rowsSelected = 0;
      if (this.$refs.tableMenuDisabled.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(this.$refs.tableMenuDisabled.getRowSelected(), function(
          i,
          row
        ) {
          adminSettingUser.rowsSelected = adminSettingUser.rowsSelected + 1;


          menuAdminCustomServices.enable(row.id,adminSettingUser.rowIdSelected, function(result) {
            adminSettingUser.checkAllMenuIsSaved();
            notificationHelpers.success(adminSettingUser.updateCompleted);
          });

          adminSettingUser.getByRole(adminSettingUser.rowIdSelected);          

          this.disableAddMenuButton = true;
          this.disableRemoveMenuButton = true;
            
        });
        
      }
    },
    removeMenu() {
      var adminSettingUser = this;
      this.rowsSelected = 0;
      if (this.$refs.tableMenuEnabled.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(this.$refs.tableMenuEnabled.getRowSelected(), function(
          i,
          row
        ) {
          adminSettingUser.rowsSelected = adminSettingUser.rowsSelected + 1;

          menuAdminCustomServices.disable(row.id,adminSettingUser.rowIdSelected, function(result) {
            adminSettingUser.checkAllMenuIsSaved();
            notificationHelpers.success(adminSettingUser.updateCompleted);
          });

          adminSettingUser.getByRole(adminSettingUser.rowIdSelected);
          
          this.disableAddMenuButton = true;
          this.disableRemoveMenuButton = true;
            
        });
        
      }
    },

    getByRole(idRole) {
      var adminSettingUser = this;
      
      menuAdminCustomServices.getByRole(idRole, function(result) {
        adminSettingUser.tableMenuEnabledData = result.data.included;
        adminSettingUser.tableMenuDisabledData = result.data.excluded;
        spinnerHelpers.hide();
      });
    },

    checkAllMenuIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        spinnerHelpers.hide();
        this.onTabMenu();
      }
    }

  }
};
</script>
<style>
.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btns {
 position: absolute;
    z-index: 1;
    margin-top: 10px;
}
</style>